export default __webpack_public_path__ + "f22892ccfab1b97f61c6b7f832c31696.png";